import React from "react";

const Experience = ({ role, period }) => {
  return (
    <div>
      <h3 className="role">{role}</h3>
      <p className="period">{period}</p>
    </div>
  );
};

export default Experience;
